import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styles from './access-gate.css';

// Beta gate password — replaced by Firebase Auth in Phase 2
// Hash this in a future iteration; for beta it's acceptable as-is
// because the gate is opacity, not security.
const BETA_PASSWORD = 'coding-board-beta-2026';
const STORAGE_KEY = 'coding-board:beta-access';
const SESSION_DAYS = 30;

const isSessionValid = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const {grantedAt} = JSON.parse(raw);
        const ageDays = (Date.now() - grantedAt) / (1000 * 60 * 60 * 24);
        return ageDays < SESSION_DAYS;
    } catch {
        return false;
    }
};

const grantSession = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({grantedAt: Date.now()}));
};

const AccessGate = ({children, onUnlock}) => {
    const [unlocked, setUnlocked] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (isSessionValid()) setUnlocked(true);
    }, []);

    // The real Studio renders itself imperatively (render-gui.jsx calls
    // ReactDOM.render directly), so it can't be passed in as `children`.
    // This callback lets the caller trigger that render once unlocked,
    // while `children` still renders normally for any other consumer.
    useEffect(() => {
        if (unlocked && onUnlock) onUnlock();
    }, [unlocked]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password.trim() === BETA_PASSWORD) {
            grantSession();
            setUnlocked(true);
        } else {
            setError(true);
            setPassword('');
        }
    };

    if (unlocked) return children;

    return (
        <div className={styles.gateContainer}>
            <div className={styles.gateCard}>
                <div className={styles.logoWrapper}>
                    <img
                        src="/static/web-app-manifest-192x192.png"
                        alt="Coding Board"
                        className={styles.logo}
                    />
                </div>
                <h1 className={styles.title}>Coding Board Studio</h1>
                <p className={styles.subtitle}>
          Acceso restringido — Beta privada
                </p>
                <form onSubmit={handleSubmit} className={styles.form}>
                    <input
                        type="password"
                        className={styles.input}
                        placeholder="Código de acceso"
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setError(false);
                        }}
                        autoFocus
                    />
                    {error && (
                        <p className={styles.error}>
              Código incorrecto. Verifica con tu profesor.
                        </p>
                    )}
                    <button type="submit" className={styles.submit}>
            Entrar
                    </button>
                </form>
                <p className={styles.footer}>
          ¿No tienes acceso? Escríbenos a{' '}
                    <a href="mailto:hola@codingboard.mx">hola@codingboard.mx</a>
                </p>
            </div>
        </div>
    );
};

AccessGate.propTypes = {
    children: PropTypes.node.isRequired,
    onUnlock: PropTypes.func
};

export default AccessGate;
